// extracted by mini-css-extract-plugin
export default {"item":"NavItem_item__a00on","item__container":"NavItem_item__container__DZ9Ou","item__content":"NavItem_item__content__CcMMp","item__arrow":"NavItem_item__arrow__ZL9nk"};